import { storage } from "./storage";

function decodeBase64Url(str: string): string {
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  if (pad) {
    base64 += '='.repeat(4 - pad);
  }
  return atob(base64);
}

export function getUserIdFromToken(): string | null {
  try {
    const token = storage.get('token');
    if (!token) {
      console.log('Token bulunamadı');
      return null;
    }

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('Token formatı geçersiz, parça sayısı:', tokenParts.length);
      return null;
    }

    const payload = JSON.parse(decodeBase64Url(tokenParts[1]));
    // console.log('JWT Payload:', payload);

    // Farklı userId alanlarını kontrol et
    const userId = payload.userId || payload.sub || payload.id || payload.user_id;
    // console.log('User ID found:', userId);
    
    if (!userId) {
      console.log('User ID bulunamadı. Payload keys:', Object.keys(payload));
      return null;
    }

    return userId;
  } catch (error) {
    console.error('getUserIdFromToken hatası:', error);
    return null;
  }
}

export function getUserRoleFromToken(): string | null {
  try {
    const token = storage.get('token');
    if (!token) {
      console.log('Token bulunamadı');
      return null;
    }

    // console.log('Token alındı, uzunluk:', token.length);
    
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('Token formatı geçersiz, parça sayısı:', tokenParts.length);
      return null;
    }

    // console.log('Token parçaları:', tokenParts.length);
    
    const payload = JSON.parse(decodeBase64Url(tokenParts[1]));
    // console.log('Token payload:', payload);
    
    if (payload.roles) {
      const roles = payload.roles.split(',').map((role: string) => role.trim());
      // console.log('Kullanıcı rolleri:', roles);
      
      if (roles.includes('ROLE_SUPER_ADMIN')) {
        // console.log('Super Admin rolü seçildi');
        return 'ROLE_SUPER_ADMIN';
      }
      if (roles.includes('ROLE_ADMIN')) {
        // console.log('Admin rolü seçildi');
        return 'ROLE_ADMIN';
      }
      if (roles.includes('ROLE_MANAGER')) {
        // console.log('Manager rolü seçildi');
        return 'ROLE_MANAGER';
      }
      if (roles.includes('ROLE_USER')) {
        // console.log('User rolü seçildi');
        return 'ROLE_USER';
      }
    }
    
    console.log('Roles alanı bulunamadı veya geçersiz');
    return null;
  } catch (error) {
    console.error('getUserRoleFromToken hatası:', error);
    return null;
  }
}

export function getUsernameFromToken(): string | null {
  try {
    const token = storage.get('token');
    if (!token) {
      console.log('Token bulunamadı');
      return null;
    }

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('Token formatı geçersiz');
      return null;
    }

    const payload = JSON.parse(decodeBase64Url(tokenParts[1]));

    // Try different possible username fields
    const username = payload.username || payload.sub || payload.name || payload.user_name;

    if (!username) {
      console.log('Username bulunamadı. Payload keys:', Object.keys(payload));
      return null;
    }

    return username;
  } catch (error) {
    console.error('getUsernameFromToken hatası:', error);
    return null;
  }
}

export function isTokenExpired(): boolean {
  try {
    const token = storage.get('token');
    if (!token) return true;

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) return true;

    const payload = JSON.parse(decodeBase64Url(tokenParts[1]));
    if (!payload.exp) return true;

    const expTime = payload.exp * 1000; // Convert to milliseconds
    const currentTime = Date.now();

    return expTime < currentTime;
  } catch (error) {
    return true;
  }
}
